import Dialog from "../dialogs/Dialog";
import {
    AppBar,
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
    Toolbar,
    Typography
}
    from "@mui/material";
import React, {useContext, useState} from "react";
import {Register, RegisterType, RegisterValue} from "../../fstn/register";
import {selectProject} from "../../redux/selectors/editor";
import {connect} from "react-redux";
import {FirebaseContext} from "../firebase/FirebaseProvider";

interface Props {
    project: string
    register: Register
    registerKey: string
    onClose: () => void
}
function RegisterDetails({project, register, registerKey, onClose}: Props) {
    const [name, setName] = useState(registerKey);
    const [value, setValue] = useState<RegisterValue>(register.get());
    const [type, setType] = useState<RegisterType>(register.type);
    const {removeRegister, setRegister} = useContext(FirebaseContext);
    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setName(event.target.value);
    }
    const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (type === "string") {
            setValue(event.target.value);
        } else {
            setValue(Number.parseFloat(event.target.value));
        }
    }
    const handleConfirmClick = () => {
        onClose();
        removeRegister(project, registerKey);
        setRegister(project, name, {value, type});
    }
    const handleChangeType = ({target}: SelectChangeEvent) => {
        setType(target.value as RegisterType);
        if (target.value === "string") {
            setValue(value as string);
        } else {
            setValue(Number.parseFloat(value as string));
        }
    }
    const handleChangeBoolean = ({target}: SelectChangeEvent) => {
        setValue(target.value === "true");
    }
    const confirmDisabled = name === registerKey && value === register.get() && type === register.type;

    return (
        <Dialog onClose={onClose}>
            <AppBar position="static">
                <Toolbar variant="dense">
                    <Box flexGrow={1}><Typography>{registerKey}</Typography></Box>
                </Toolbar>
            </AppBar>
            <Box p={2} width={500}>
                <TextField label="Register Name" value={name} fullWidth
                           onChange={handleNameChange}/>
                <FormControl fullWidth>
                    <InputLabel id="select-type">Register Type</InputLabel>
                    <Select labelId="select-type" value={type} onChange={handleChangeType}>
                        <MenuItem value="boolean">Boolean</MenuItem>
                        <MenuItem value="number">Number</MenuItem>
                        <MenuItem value="string">String</MenuItem>
                    </Select>
                </FormControl>
                {type === "boolean" ?
                    <FormControl fullWidth>
                        <InputLabel id="select-type">Register Value</InputLabel>
                        <Select labelId="select-type" value={value as string} onChange={handleChangeBoolean}>
                            <MenuItem value="true">True</MenuItem>
                            <MenuItem value="false">False</MenuItem>
                        </Select>
                    </FormControl>
                    :
                    <TextField label="Default value" value={value} fullWidth type={type}
                               onChange={handleValueChange}/>
                }
                <Box paddingTop={1} display="flex" justifyContent="right">
                    <Box m={1}>
                        <Button
                            disabled={confirmDisabled} variant="contained" color="primary"
                            onClick={handleConfirmClick}>
                            Confirm
                        </Button>
                    </Box>
                    <Box m={1}>
                        <Button variant="contained" onClick={onClose}>Cancel</Button>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    );
}
const mapStateToProps = (store: never) => ({
    project: selectProject(store)
});

export default connect(mapStateToProps, {
})(RegisterDetails);
